import { AdvertisementActionTypes } from '../actions/advertisement.actions'

export type AdvertisementStatus = 'active' | 'inactive'

export interface Advertisement {
    id: string
    image: string
    link: string
    status: AdvertisementStatus
    createdAt?: string
    updatedAt?: string
}

const initialState: Advertisement[] = []

const advertisementReducer = (state: Advertisement[] = initialState, action: any): Advertisement[] => {
    switch (action.type) {
        case AdvertisementActionTypes.ADD_ADVERTISEMENT: {
            return [
                action.data,
                ...state
            ]
        }

        case AdvertisementActionTypes.UPDATE_ADVERTISEMENT: {
            const advertisements = [...state]
            const index = advertisements.findIndex(item => item.id === action.data.id)

            if (index > -1) {
                advertisements[index] = {
                    ...advertisements[index],
                    ...action.data
                }
            }

            return advertisements
        }

        case AdvertisementActionTypes.FETCH_ADVERTISEMENTS: {
            return action.data
        }

        case AdvertisementActionTypes.DELETE_ADVERTISEMENT: {
            return state.filter(item => item.id !== action.data)
        }

        default: {
            return state
        }
    }
}

export default advertisementReducer
